export default __webpack_public_path__ + "static/media/Jimny.0eceae17.png";